;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/capacity/:id\",\"regex\":\"^/capacity/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/orgs/:id\",\"regex\":\"^/orgs/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/users/:id\",\"regex\":\"^/users/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/admins\"},{\"path\":\"/capacity\"},{\"path\":\"/credits\"},{\"path\":\"/flags\"},{\"path\":\"/load-balancers\"},{\"path\":\"/orgs\"},{\"path\":\"/tools\"},{\"path\":\"/users\"},{\"path\":\"/login\"},{\"path\":\"/login/verify\"},{\"path\":\"/password\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from "@sentry/nextjs";
import { isSentinelValue } from "@/lib/env";
import { getSharedSentryOptions, parseSampleRate } from "@/lib/sentry/config";

const publicProfilesSampleRate = process.env.NEXT_PUBLIC_SENTRY_PROFILES_SAMPLE_RATE;

Sentry.init({
  ...getSharedSentryOptions(),
  integrations: [Sentry.browserTracingIntegration(), Sentry.consoleLoggingIntegration()],
  profileSessionSampleRate: parseSampleRate(
    publicProfilesSampleRate && !isSentinelValue(publicProfilesSampleRate)
      ? publicProfilesSampleRate
      : process.env.SENTRY_PROFILES_SAMPLE_RATE,
    0.1,
  ),
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
